import { supabase } from "../../supabaseClient"

export async function signIn(email, password) {
  return await supabase.auth.signInWithPassword({
    email,
    password
  })
}

export async function signUp(email, password) {
  return await supabase.auth.signUp({
    email,
    password
  })
}

export async function signOut() {
  return await supabase.auth.signOut()
}

export async function resetPassword(email) {
  return await supabase.auth.resetPasswordForEmail(email)
}

export async function getSession() {
  return await supabase.auth.getSession()
}

export function onAuthStateChange(callback) {
  return supabase.auth.onAuthStateChange(callback)
}

export async function loadCurrentUser(session) {

  if (!session?.user) {
    return null
  }

  console.log(
  "LOAD CURRENT USER FOR:",
  session.user.id,
  session.user.email
)

  // ==============================
  // Load Profile
  // ==============================

  console.log(
  "PROFILE QUERY START:",
  session.user.id,
  session.user.email
)
  const {
    data: profile,
    error: profileError
  } = await supabase
    .from("profiles")
    .select("*")
    .eq("id", session.user.id)
    .maybeSingle()

    console.log(
  "PROFILE QUERY RESULT:",
  {
    sessionUserId: session.user.id,
    sessionEmail: session.user.email,
    profileId: profile?.id,
    profileEmail: profile?.email,
    profileDisplayName: profile?.display_name,
    profileError
  }
)

  if (profileError) {
    throw profileError
  }

  // ==============================
  // Load User Preferences
  // ==============================

  const {
    data: preferences,
    error: preferencesError
  } = await supabase
    .from("user_preferences")
    .select("*")
    .eq("user_id", session.user.id)
    .maybeSingle()

  if (preferencesError) {
    throw preferencesError
  }

  // Remove database keys that would overwrite
  // the user's real profile id.
  const {
    id,
    user_id,
    created_at,
    updated_at,
    ...preferenceFields
  } = preferences ?? {}

  // ==============================
  // Build Current User
  // ==============================

  console.log(
  "LOAD CURRENT USER RETURNING:",
  {
    profileId: profile?.id,
    profileEmail: profile?.email,
    profileDisplayName: profile?.display_name
  }
)

  return {
    ...(profile ?? {}),
    ...preferenceFields
  }

}